<template>

  <li
    class="list-group-item"
    :class="{'box-loading': loading, 'list-group-item-secondary': edit, 'p-4': edit}">
    
    <div
      v-if="!edit"
      class="d-flex">
      <div>
        <div
          class="check-task"
          :class="{'completed': task.completed}"
          @click="checkCompleted(!task.completed)">
          <i class="far fa-check-circle" v-if="!task.completed" />
          <i class="fas fa-check-circle" v-if="task.completed" />
        </div>
      </div>
      <div class="w-100 mx-3">
        <div>
          <strong :class="{'text-danger': late, 'text-success': task.completed}">{{ $d(new Date(task.date), 'long') }}</strong>
        </div>
        <div>
          <a
            href="javascript:void(0)"
            class="link-discreet"
            @click="redirect(task)">
            {{ task.candidate_id.name }}
            </a>
        </div>
        <div class="my-3" style="white-space: pre-wrap;">{{ task.comment }}</div>
        <div>
          <small
            v-if="task.assigned_user_id"
            class="text-muted">
            atribuída à {{ task.assigned_user_id.name }}
            </small>
        </div>
      </div>
      <div>
        <div
          v-if="permissions.includes('manage_candidates')"
          class="feed-actions dropdown">
          <button
            class="btn btn-sm btn-light"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            <i class="fas fa-chevron-down" />
          </button>
          <div class="dropdown-menu dropdown-menu-right">
            <button
              class="dropdown-item"
              @click="editTask(task)">
                <i class="fas fa-pencil-alt" /> {{ $t('Edit') }}
              </button>
            <button
                class="dropdown-item"
                @click="deleteTask(task._id)">
                <i class="fas fa-times" /> {{ $t('Remove') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="edit">
      <div class="card">
        <div class="card-header">
          Editar tarefa
        </div>
        <div class="card-body">
          <candidate-task-form
            :initValue="edit"
            @updated="updatedTask"
            @cancel="editCancel">
            </candidate-task-form>
        </div>
      </div>
    </div>

  </li>

</template>

<script>
import moment from 'moment'
import CandidateTaskForm from '@/components/Candidate/Task/CandidateTaskForm'

export default {
  name: 'TaskListItem',
  components: {
    CandidateTaskForm
  },
  props: {
    task: {
      type: Object
    }
  },
  data () {
    return {
      loading: false,
      edit: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    late () {
      return moment(this.task.date).diff() <= 0 && !this.task.completed
    }
  },
  created () {
  },
  methods: {
    editTask (data) {
      this.edit = data
    },
    editCancel () {
      this.edit = false
    },
    updatedTask (task) {
      this.$store.dispatch('refreshSelectTasks')
      this.editCancel()
    },
    deleteTask (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteTask', id)
        .then((result) => {
          this.loading = false
          this.$store.dispatch('refreshSelectTasks')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    },
    /*
    checkCompleted
    */
    checkCompleted (completed) {
      this.loading = true

      this.$store
      .dispatch('updateTask', {
        _id: this.task._id,
        completed: completed
      })
      .then(result => {
        this.loading = false
        this.$emit('updated')
      })
    },
    /*
    redirect
    */
    redirect (task) {
      this.$openCandidateModal(task.candidate_id._id, {
        candidate_job_id: task.job_id,
        candidate_tab: 'task'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Task/TaskListItem.vue